import { Bus } from '@atlas/core';

import history from 'components/MainRouter/history';

export const createEventHandlers = ({ iframeRef }) => {
  const onPageHeightChange = eventData => {
    const iframe = iframeRef.current;

    if (iframe && eventData?.height) {
      iframe.style.height = `${eventData.height}px`;
    }
  };

  const onScrollToTop = () => {
    Bus.emit('ui:scroll:content', {
      behavior: 'auto',
      scrollTo: 0,
    });
  };

  const onOpenSignInPopup = () => {
    const { pathname } = history.location;
    history.push(`${pathname}?cmd=signin`);
  };

  return {
    ON_PAGE_HEIGHT_CHANGE: onPageHeightChange,
    PLACE_BET_CLICKED_NOT_LOGGED_IN: onOpenSignInPopup,
    SCROLL_TO_TOP: onScrollToTop,
  };
};
